import {TargetBlank} from '@wandb/weave/common/util/links';
import React from 'react';
// @todo: Migrate to 'Link' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Link} from 'react-router-dom';

import emptyImg from '../../assets/il-no-visuals-yet.png';
import emptyImg2x from '../../assets/il-no-visuals-yet@2x.png';
import EmptyWatermark from '../../components/EmptyWatermark';
import DOC_URLS from '../../util/doc_urls';
import * as urls from '../../util/urls';
import {Theme} from '../Benchmark/benchmarkTypes';
import {useProjectParams} from './useProjectParams';

type EmptyStateProps = {
  linkedBenchmarkInfo?: Theme | null;
};

export const EmptyState = ({linkedBenchmarkInfo}: EmptyStateProps) => {
  const {entityName, projectName} = useProjectParams();

  return (
    <EmptyWatermark
      style={{marginTop: 74}}
      imageSource={emptyImg}
      imageSource2x={emptyImg2x}
      header="You haven't logged any runs yet."
      details={
        <>
          Visit the{' '}
          {linkedBenchmarkInfo != null ? (
            <Link
              to={urls.projectLinkedBenchmark({
                entityName,
                name: projectName,
              })}>
              Benchmark tab
            </Link>
          ) : (
            <TargetBlank href={DOC_URLS.root}>Documentation</TargetBlank>
          )}{' '}
          to get started.
        </>
      }
    />
  );
};
